export const ServiceTokens = {
  CallActor: 'callActor',
  Call: 'call',
  QualityOfService: 'qualityOfService',
  Config: 'config',
  Logger: 'logger',
  Media: 'media',
  Session: 'session',
  Realtime: 'realtime',
  PatientRealtime: 'patientRealtime',
  ProviderRealtime: 'providerRealtime',
  CallHistory: 'callHistory',
  CommonRealtime: 'commonRealtime',
  ReduxStore: 'reduxStore',
  FileHosting: 'fileHosting',
  PhotoCapture: 'photoCapture',
  Transcription: 'transcription',
  GrowthBook: 'growthBook',
} as const;
